import { render, staticRenderFns } from "./UpsShipmentModal.vue?vue&type=template&id=052bdc76&scoped=true"
import script from "./UpsShipmentModal.vue?vue&type=script&lang=js"
export * from "./UpsShipmentModal.vue?vue&type=script&lang=js"
import style0 from "./UpsShipmentModal.vue?vue&type=style&index=0&id=052bdc76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052bdc76",
  null
  
)

export default component.exports